module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Amy Erickson\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Amy Erickson")]), _vm._v(" is professor of Hebrew Bible and director of the Master of Theological Studies program at the Iliff School of Theology.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/6tBMs9/tc-custom/9781467461306.jpg?1742010627861",
      "alt": "This image is the cover for the book Jonah, Illuminations (ILLUM)"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Jonah, Illuminations (ILLUM)\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The dominant reading of the book of Jonah—that the hapless prophet Jonah is a lesson in not trying to run away from God—oversimplifies a profoundly literary biblical text, argues Amy Erickson. Likewise, the more recent understanding of Jonah as satire is problematic in its own right, laden as it is with anti-Jewish undertones and the superimposition of a Christian worldview onto a Jewish text. How can we move away from these stale interpretations to recover the richness of meaning that belongs to this short but noteworthy book of the Bible? ")]), _c('p', [_vm._v("This Illuminations commentary delves into Jonah’s reception history in Christian, Jewish, and Islamic contexts while also exploring its representations in visual arts, music, literature, and pop culture. After this thorough contextualization, Erickson provides a fresh translation and exegesis, paving the way for pastors and scholars to read and utilize the book of Jonah as the provocative, richly allusive, and theologically robust text that it is.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Wm. B. Eerdmans Publishing Co.\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0